/**
 * CRM user work locations
 */

export const WORK_LOCATIONS = {
    office: 'Office',
    remote: 'Remote',
    hybrid: 'Hybrid'
};

export const WORK_LOCATION_ORDER = Object.keys(WORK_LOCATIONS);
